import React from 'react';

function VoiceBetaModal({ open, onClose, onBegin, role = 'counsellor' }) {
  if (!open) {
    return null;
  }
  const isClientRole = role === 'client';

  return (
    <div className="oars-info-overlay" onClick={onClose}>
      <div className="oars-info-modal" onClick={(e) => e.stopPropagation()}>
        <button className="oars-info-modal__close" onClick={onClose} aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <div className="oars-info-modal__body">
          <h3>Voice Mode is currently in beta</h3>
          {isClientRole ? (
            <p>This mode lets you speak out loud instead of typing during a Be the Client session. AIMIE listens to your spoken response as the client, transcribes it, sends it through the same conversation pipeline, and then speaks the counsellor&apos;s reply back to you.</p>
          ) : (
            <p>This mode lets you speak out loud instead of typing during a free form session. AIMIE listens to your spoken counsellor response, transcribes it, sends it through the same conversation pipeline, and then speaks the virtual client&apos;s reply back to you.</p>
          )}
          <p>In this mode, you can have a spoken back-and-forth conversation {isClientRole ? 'with the counsellor' : 'with the virtual client'} while still seeing the conversation appear in the chat window. Session insights and analytics continue updating in the background just like they do in text mode.</p>
          <p>Please note that this feature is still in beta. It is usable, but there are still bugs we are actively trying to resolve. You may occasionally notice issues such as delayed turn-taking, mismatches between spoken and displayed responses, or other unstable behavior.</p>
          <p>If anything seems off, the safest fallback is to exit voice mode and continue the same session in text mode.</p>
        </div>
        <div className="oars-skill-modal__footer">
          <button
            type="button"
            className="oars-modal-begin-btn"
            onClick={onBegin}
          >
            Begin
          </button>
        </div>
      </div>
    </div>
  );
}

export default VoiceBetaModal;
